<template>
  <div class="odmik-vsebine-poraba-telefonija">
    <div v-show="prikazTabele === '1'">
      <el-table :data="seznamporabaSapVseStevilke" empty-text="Ni podatkov za prikaz"
               v-loading="nalaganjeVsebineVseStevilke" width="100%">
        <el-table-column prop="access_details" label="Številka">
          <div slot-scope="{row}">
            <a href="javascript:void(0)"
               @click="IzbranaStevilkaOsnovnegaPregleda(row.access_details)"
               class="primarna-barva">
              {{ row.access_details }}
            </a>
          </div>
        </el-table-column>
        <el-table-column prop="actual_quantity"
                         label="Trajanje klicev (v.sek)">
        </el-table-column>
        <el-table-column prop="actual_quantity_event"
                         label="Število sporočil">
        </el-table-column>
        <el-table-column prop="pretvorbaPodatkovniPromet"
                         label="Podatkovni promet">
        </el-table-column>
        <el-table-column prop="pretvorbaZnesek"
                         label="Znesek v € (z DDV)">
        </el-table-column>
      </el-table>
    </div>
    <div v-show="prikazTabele === '0'">
      <el-table :data="seznamporabaSapVseStevilke" empty-text="Ni podatkov za prikaz"
                v-loading="nalaganjeVsebineVseStevilke">
        <el-table-column>
          <template slot-scope="props">
            <p>
              <span>
                <b>
                  Številka:
                </b>
              </span>
              <a href="javascript:void(0)"
                 @click="IzbranaStevilkaOsnovnegaPregleda(props.row.access_details)"
                 class="primarna-barva">
                {{ props.row.access_details }}
              </a>
            </p>
            <p>
              <span>
                <b>
                  Trajanje klicev (v.sek):
                </b>
              </span>
              {{ props.row.actual_quantity }}
            </p>
            <p>
              <span>
                <b>
                  Število sporočil:
                </b>
              </span>
              {{ props.row.actual_quantity_event }}
            </p>
            <p>
              <span>
                <b>
                  Podatkovni promet:
                </b>
              </span>
              {{ props.row.pretvorbaPodatkovniPromet }}
            </p>
            <p>
              <span>
                <b>
                  Znesek v € (z DDV):
                </b>
              </span>
              {{ props.row.pretvorbaZnesek }}
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center">
      <el-pagination
        :hide-on-single-page="true"
        @current-change="PrikaziStran"
        :current-page="trenutnoIzbranaStran"
        :page-size="8"
        layout="prev, pager, next"
        :total="dolzinaSeznamaOsnovniPregled"
        small>
      </el-pagination>
    </div>
    <div class="postavitev-izvoz-porabe">
      <span class="navadno-besedilo" style="min-width: 105px">
        <el-checkbox v-model="outgoingCalls"/>
        <span :class="!outgoingCalls || 'krepko'">
          Izhodni klici
        </span>
      </span>
      <span class="navadno-besedilo" style="min-width: 110px">
        <el-checkbox v-model="incomingCalls"/>
        <span :class="!incomingCalls || 'krepko'">
          Dohodni klici
        </span>
      </span>
      <span class="navadno-besedilo" style="min-width: 170px">
        <el-checkbox v-model="smsMmsData"/>
        <span :class="!smsMmsData || 'krepko'">
          SMS / MMS / PODATKI
        </span>
      </span>
      <el-button
        style="min-width: 160px; min-height: 43px"
        class="gumb-potrdi"
        @click="IzvozExcel"
        :disabled="!smsMmsData && !incomingCalls && !outgoingCalls">
        <img src="../../../../../../static/img/Icon/PorabaTelefonija/Icon-file-excel-regular.png">
        IZVOZ PORABE
      </el-button>
    </div>
    <span class="opozorilo">
      <el-icon class="el-icon-info" style="padding-top:5px">
      </el-icon>
      <span class="opozorilo-mobile">
        Skupen izpis porabe je informativne narave, zgodovino vseh številk beležimo za zadnje 3 mesece, cene so v evrih
        in natančne do četrte decimalke.
      </span>
    </span>
  </div>
</template>
<script>
import {ObdelavaDatuma} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/IzbiraMeseca.js'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import {Checkbox, Button, Select, Option, Card, Table, TableColumn, Tooltip, Pagination} from 'element-ui'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {PrenosDatoteke} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke'

export default {
  name: 'VseStevilke',
  mixins: [PrikazVsebine, ObdelavaDatuma, PretvorbaEnot, StringConverter, PrenosDatoteke],
  data () {
    return {
      clientAgent: null,
      nalaganjeVsebineVseStevilke: false,
      pretvorbaPodatkovniPromet: '',
      izpisZakupljenihEnot: true,
      porabaSapVseStevilke: [],
      seznamporabaSapVseStevilke: [],
      dolzinaSeznamaOsnovniPregled: null,
      trenutnoIzbranaStran: 1,
      mobilniPodatki: false,
      povezavaSplosniPogoji: '',
      smsMmsData: true,
      incomingCalls: true,
      outgoingCalls: true
    }
  },
  components: {
    ObdelavaDatuma,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  props: {
    izbranSap: null,
    izbranMesec: ''
  },
  watch: {
    izbranSap: function () {
      if (this.izbranSap !== '') {
        this.GetPorabaInfo()
      }
    },
    izbranMesec: function () {
      if (this.izbranMesec !== '') {
        this.GetPorabaInfo()
      }
    }
  },
  mounted () {
    this.povezavaSplosniPogoji = povezave.BASE_URL_SPLOSNI_POGOJI
    this.clientAgent = new ClientAgent()
    this.DolociIzbranMesec()
    this.PretvoriKolicinoVPrijaznoObliko()
    this.GetPorabaInfo()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    OdpriPregledMobilniPodatki () {
      this.mobilniPodatki = true
    },
    ZapriPregledMobilniPodatki () {
      this.mobilniPodatki = false
    },
    IzbranaStevilkaOsnovnegaPregleda (izbranaStevilka) {
      this.$emit('osveziStranPregledaPorabe', izbranaStevilka)
    },
    IzvozExcel () {
      if (this.izbranSap !== '') {
        if (this.telefonskaStevilka !== null && this.telefonskaStevilka !== '') {
          let izbranoObdobje = this.DolociIzbranMesec()
          let param = ['sap=' + this.izbranSap]
          param.push('datumOd=' + izbranoObdobje.trajanjeOd)
          param.push('datumDo=' + izbranoObdobje.trajanjeDo)
          param.push('izpisZakuplenihEnot=' + this.izpisZakupljenihEnot)
          param.push('izvoz=true')
          const values = []
          if ((this.incomingCalls || this.outgoingCalls) && !this.smsMmsData) {
            values.push('tip=voice')
          } else if (this.smsMmsData && !this.incomingCalls && !this.outgoingCalls) {
            values.push('tip=message')
          } else {
            values.push('tip=all')
          }
          if (this.incomingCalls || this.outgoingCalls) {
            values.push(`smerKlica=${this.incomingCalls}`)
          }
          param.push(...values)
          this.clientAgent.postWsRequest(
            this,
            'mercury/poraba',
            param,
            null,
            'SetPorabaIzvoz',
            'ErrPorabaIzvoz',
            300000)
        }
      }
    },
    SetPorabaIzvoz (podatki) {
      let data = podatki.exportData
      this.PrenesiDatoteko('data:application/xls;base64,' + data, 'Osnovni-pregled-vseh-stevilk.xls')
    },
    ErrPorabaIzvoz (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetPorabaInfo () {
      if (this.izbranSap !== '') {
        this.nalaganjeVsebineVseStevilke = true
        let izbranoObdobje = this.DolociIzbranMesec()
        let param = ['sap=' + this.izbranSap]
        param.push('datumOd=' + izbranoObdobje.trajanjeOd)
        param.push('datumDo=' + izbranoObdobje.trajanjeDo)
        param.push('izpisZakuplenihEnot=' + this.izpisZakupljenihEnot)
        this.clientAgent.postWsRequest(
          this,
          'mercury/porabaSap',
          param,
          null,
          'SetPorabaSap',
          'ErrPorabaSap')
      }
    },
    SetPorabaSap (podatki) {
      this.pretvorbaPodatkovniPromet = ''
      this.porabaSapVseStevilke = []
      this.porabaSapVseStevilke = podatki.data
      if (this.porabaSapVseStevilke.length !== 1 || this.porabaSapVseStevilke[0] !== 'no calls') {
        for (let i = 0; i < this.porabaSapVseStevilke.length; i++) {
          if (this.porabaSapVseStevilke[i].actual_quantity_volume !== null) {
            let porabaObj = this.PretvoriKolicinoVPrijaznoObliko(this.porabaSapVseStevilke[i].actual_quantity_volume)
            this.porabaSapVseStevilke[i].pretvorbaPodatkovniPromet = porabaObj
          } else {
            this.porabaSapVseStevilke[i].pretvorbaPodatkovniPromet = 0
          }
          this.davek = (100 + parseFloat(this.porabaSapVseStevilke[i].vat)) / 100
          this.porabaSapVseStevilke[i].pretvorbaZnesek =
            (((this.porabaSapVseStevilke[i].amount * this.davek) / 100)
              .toFixed(4).replace('.', ',') + ' €')
          if (this.porabaSapVseStevilke[i].actual_quantity === null) {
            this.porabaSapVseStevilke[i].actual_quantity = 0
          }
        }
      }
      if (this.porabaSapVseStevilke !== null) {
        let tmpArray = []
        this.dolzinaSeznamaOsnovniPregled = this.porabaSapVseStevilke.length
        const chunk = 8
        for (let i = 0; i < this.dolzinaSeznamaOsnovniPregled; i += chunk) {
          tmpArray.push(this.porabaSapVseStevilke.slice(i, i + chunk))
        }
        this.porabaSapVseStevilke = tmpArray
        this.PrikaziStran(1)
      }
    },
    PrikaziStran (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.porabaSapVseStevilke[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamporabaSapVseStevilke = this.porabaSapVseStevilke[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamporabaSapVseStevilke = []
      }
      this.nalaganjeVsebineVseStevilke = false
    },
    ErrPorabaSap (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeVsebineVseStevilke = false
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Poraba/PorabaTelefonija/OsnovniPregled.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija/OsnovniPregled.vue